import React, {Component} from 'react';

import {CardDeck, Col, Row} from 'reactstrap';

import {BasicCard, BioCard, EmploymentHistoryCard, GeneralCard, RentalHistoryCard, VehicleCard} from "./ApplicationCards";

class ApplicationDisplay extends Component {
    render() {
        const {application, noName} = this.props;

        return (
            <div>
                {
                    !noName && (
                        <Row>
                            <Col><h3><strong>{application.first_name + ' ' + application.middle_name + ' ' + application.last_name}</strong></h3></Col>
                        </Row>
                    )
                }


                <Row>
                    <Col>
                        <CardDeck>
                            <BasicCard application={application}/>
                            <VehicleCard application={application}/>
                        </CardDeck>
                    </Col>
                </Row>

                <Row>
                    <Col>
                        <RentalHistoryCard rental_history={application.rental_history_rentals}/>
                    </Col>
                </Row>

                <Row>
                    <Col>
                        <EmploymentHistoryCard employment_history={application.employment_history_positions}/>
                    </Col>
                </Row>

                <Row>
                    <Col>
                        <GeneralCard application={application}/>
                    </Col>
                </Row>

                <Row>
                    <Col>
                        <BioCard application={application}/>
                    </Col>
                </Row>
            </div>
        );
    }
}

export default ApplicationDisplay;


// WEBPACK FOOTER //
// ./src/components/application/ApplicationDisplay.js